import script from "./noRight.vue?vue&type=script&setup=true&lang=js"
export * from "./noRight.vue?vue&type=script&setup=true&lang=js"

import "./noRight.vue?vue&type=style&index=0&id=7871c002&lang=scss&scoped=true"

import exportComponent from "/Users/yangxu/work/js_celue-zuhe_src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7871c002"]])

export default __exports__